module.exports = __webpack_public_path__ + "static/media/KarimBenzema_thumbnail.d64c0fbe.png";